import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-self-service',
    templateUrl: './self-service.component.html',
    styleUrls: ['./self-service.component.scss'],
})
export class SelfServiceComponent implements OnInit {
    @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;

    constructor(
        private translateService: TranslateService,
        private titleService: Title,
    ) {}

    ngOnInit() {
        this.translateService.get('SELF_SERVICE.META.DOCUMENT_TITLE').subscribe((title) => {
            this.titleService.setTitle(title);
        });
    }

    toggleSidenav() {
        this.sidenav.toggle();
    }
}
